<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div
    id="kt_app_toolbar_container"
    class="app-container container-fluid d-flex flex-stack"
  >
    <!--begin::Page title-->
    <div
      class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
    >
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading">
          <svg
            width="41"
            height="44"
            viewBox="0 0 41 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_615_2549)">
              <path
                d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z"
                fill="#265D91"
              />
              <path
                d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z"
                fill="#265D91"
              />
              <path
                d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z"
                fill="#265D91"
              />
              <path
                d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z"
                fill="#265D91"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_615_2549"
                x="0.756836"
                y="0.158081"
                width="39.501"
                height="43.6498"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_615_2549"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_615_2549"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>

          Appel d'offre
        </h1>
        <!--begin::Menu-->
      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul
        class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
      >
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a routerLink="/accueil" class="text-muted">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">Détails appel d'offre</li>
        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->
    <div class="carddown" *ngIf="jobofferDetails">
      <div class="card-body btn-postuler">
        <a class="postuler" (click)="retirercandidature()"
          >Retirer la candidature</a
        >
      </div>
    </div>
    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>

<div id="kt_app_content" class="app-content flex-column-fluid">
  <!--begin::Content container-->
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Layout-->
    <div class="d-flex flex-column flex-xl-row block1" *ngIf="jobofferDetails">
      <!--begin::Sidebar-->
      <div class="flex-column flex-lg-row-auto w-100 w-xl-500px mb-10">
        <!--begin::Card-->
        <div class="card-wrap mb-5 mb-xl-8">
          <!--begin::Card body-->
          <!-- <div class="card-body pt-15 position-relative" *ngIf="Candidate_info"> -->
          <div class="card-body pt-15 position-relative">
            <!--begin::Summary-->
            <div class="d-flex flex-center flex-column mb-5">
              <!--begin::Avatar-->
              <div class="symbol symbol-150px symbol-circle mb-7">
                <img *ngIf="jobofferDetails?.e_s_n?.logo &&  jobofferDetails?.e_s_n?.logo!=='undefined'"
                src="{{url+'/Company/file/gallery_company/'+ jobofferDetails?.e_s_n?.logo}}"
                      alt=""
                    />
                       <img *ngIf="!jobofferDetails?.e_s_n?.logo ||  jobofferDetails?.e_s_n?.logo==='undefined'"
                       src="/assets/media/avatar.png"
                      alt=""
                    />
                <!-- <img [src]="image_url" /> -->
                <!-- <img *ngIf="!image_url?.includes('avatar')" src={{image_url}} class="img-profile" />
                                <img *ngIf="image_url && image_url?.includes('avatar')" src="assets/media/avatars/blank.png" class="img-profile" /> -->
                <!-- <img *ngIf="Candidate_info.image_url&&Candidate_info.image_url!='avatar.png'"
                                    src="{{ url+'/api/User/file/gallery_users/' + Candidate_info.image_url }}" alt="">
                                <img *ngIf="Candidate_info.image_url&&Candidate_info.image_url=='avatar.png'"
                                    class="table-img" src="assets/media/avatars/blank.png" alt="" width="75px"> -->
                <!-- <img src="/assets/media/society.png" alt="" class="image-esn"> -->
              </div>
              <!--end::Avatar-->
              <!--begin::Name-->
              <a class="title-esn text-center mb-1">
                <p>
                  {{
                    jobofferDetails?.e_s_n?.name
                      ? jobofferDetails?.e_s_n?.name
                      : "---"
                  }}
                  <!-- <span>
                    ({{
                      jobofferDetails?.e_s_n?.type == "1"
                        ? "Entreprise"
                        : jobofferDetails?.e_s_n?.type == "2"
                        ? "ESN"
                        : jobofferDetails?.e_s_n?.type == "3"
                        ? "Client Final"
                        : jobofferDetails?.e_s_n?.type == "4"
                        ? "Cabinet de Recrutement"
                        :  "---"
                    }})
                  </span> -->

                  <ng-container   *ngIf="jobofferDetails?.e_s_n?.type
                  =='2'" > <span  class="wrapping" class="esn-type" >Esn</span></ng-container> 
                   <ng-container   *ngIf="jobofferDetails?.e_s_n?.type=='3'" > <span  class="wrapping" class="client-type" >Client Final</span></ng-container> 
                   <ng-container  *ngIf="jobofferDetails?.e_s_n?.type=='4'" > <span  class="wrapping" class="cabinet-type" > Cabinet de Recrutement </span></ng-container>  


                  <!-- <ng-container  *ngIf="jobofferDetails?.client_final?.type=='3'" > Client Final</ng-container>  -->
                </p>
                <span>{{
                  jobofferDetails?.name ? jobofferDetails?.name : "---"
                }}</span>
              </a>
              <!--end::Name-->
              <!--begin::Email-->

              <!--end::Email-->
            </div>
            <!--end::Summary-->
            <!--begin::Details toggle-->
            <div class="py-3 text-center title-bg">
              <div class="contact">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 50 50"
                  width="22px"
                  height="22px"
                >
                  <path
                    d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"
                    fill="#265D91"
                  />
                </svg>
                Détails
              </div>
              <!--begin::Badge-->

              <!--begin::Badge-->
            </div>
            <!--end::Details toggle-->

            <!--begin::Details content-->
            <div class="contact-info pb-5 fs-6">
              <!--begin::Details item-->
              <div class="flex-space">
                <div class="contact-info-name">Nom Consultant</div>
                <div
                  class="poste cursor-pointer underline"
                  [routerLink]="[
                    '/candidats/profilecandidatesn',
                    jobofferDetails?.User_id
                  ]"
                >
                  {{
                    jobofferDetails?.User_full_name
                      ? jobofferDetails?.User_full_name
                      : "---"
                  }}
                </div>
              </div>

              <div class="flex-space">
                <div class="contact-info-name">Année d'éxperience</div>
                <div class="text-gray-600">
                  {{
                    jobofferDetails?.years_of_experience
                      ? jobofferDetails?.years_of_experience
                      : "---"
                  }}
                  ans
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Type de contrat</div>
                <div
                  class="text-gray-600 wrapping-right"
                  *ngIf="jobofferDetails?.contract_type.length"
                >
                  <ng-container
                    *ngFor="let type of jobofferDetails?.contract_type"
                  >
                    <div
                      *ngIf="type == 1"
                      class="text-gray-600 "
                    >
                      Alternance
                    </div>
                    <div
                      *ngIf="type == 2"
                      class="text-gray-600 "
                    >
                      Autres type de contrat
                    </div>
                    <div
                      *ngIf="type == 3"
                      class="text-gray-600 "
                    >
                      CDD
                    </div>
                    <div
                      *ngIf="type == 4"
                      class="text-gray-600 "
                    >
                      CDI
                    </div>
                    <div
                      *ngIf="type == 5"
                      class="text-gray-600 "
                    >
                      Freelance
                    </div>
                    <div
                      *ngIf="type == 6"
                      class="text-gray-600 "
                    >
                      Portage salarial
                    </div>
                    <div
                      *ngIf="type == 7"
                      class="text-gray-600 "
                    >
                      Stage
                    </div>
                  </ng-container>
                </div>
                <span *ngIf="!jobofferDetails?.contract_type.length">---</span>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Salaire</div>
                <div class="text-gray-600">
                  {{
                    jobofferDetails?.salary
                      ? jobofferDetails?.salary + "&euro;"
                      : "---"
                  }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">TJM</div>
                <div class="text-gray-600">
                  {{
                    jobofferDetails?.tjm
                      ? jobofferDetails?.tjm + "&euro;"
                      : "---"
                  }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Disponibilité</div>
                <div *ngIf="jobofferDetails?.availability == 1" class="text-gray-600">
                  Immédiate
                </div>
  
                <div *ngIf="jobofferDetails?.availability == 2" class="text-gray-600">
                  2 mois
                </div>
                <div *ngIf="jobofferDetails?.availability == 3" class="text-gray-600">
                  3 mois
                </div>
                <div *ngIf="jobofferDetails?.availability == 4" class="text-gray-600">
                  4 mois
                </div>

                <span class="text-gray-600" *ngIf="!jobofferDetails?.availability">---</span>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Type de poste</div>
                <div class="text-gray-600">
                  <div
                    *ngIf="jobofferDetails?.post_type == 1"
                    class="text-gray-600 "
                  >
                    A distance
                  </div>
                  <div
                    *ngIf="jobofferDetails?.post_type == 2"
                    class="text-gray-600"
                  >
                    Hybride
                  </div>
                  <div
                    *ngIf="jobofferDetails?.post_type == 3"
                    class="text-gray-600 "
                  >
                    Sur site
                  </div>
                </div>
                <span *ngIf="!jobofferDetails?.post_type">---</span>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Pays destinataire</div>
                <div class="text-gray-600 wrapping-right">
                  <div *ngIf="jobofferDetails?.country?.length > 0; else noCountry">
                    <div *ngFor="let country of jobofferDetails.country">
                      {{ country }}
                    </div>
                  </div>
                  <ng-template #noCountry>
                    ---
                  </ng-template>
                  
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Ville</div>
                <div class="text-gray-600 wrapping-right">
                  <div *ngIf="jobofferDetails?.city?.length > 0; else noCity">
                    <div *ngFor="let city of jobofferDetails.city">
                      {{ city }}
                    </div>
                  </div>
                  <ng-template #noCity>
                    ---
                  </ng-template>
                  
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">
                  Profil résident à l’étrangers
                </div>
                <div
                  class="text-gray-600"
                  *ngIf="jobofferDetails?.profile_abroad == 1"
                >
                  Oui
                </div>
                <div
                  class="text-gray-600"
                  *ngIf="jobofferDetails?.profile_abroad == 0"
                >
                  Non
                </div>
                <div
                  class="text-gray-600"
                  *ngIf="jobofferDetails?.profile_abroad == null"
                >
                  ---
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Passeport talent</div>
                <div
                  class="text-gray-600"
                  *ngIf="jobofferDetails?.passeport_talent == 1"
                >
                  Oui
                </div>
                <div
                  class="text-gray-600"
                  *ngIf="jobofferDetails?.passeport_talent == 0"
                >
                  Non
                </div>
                <div
                  class="text-gray-600"
                  *ngIf="jobofferDetails?.passeport_talent == null"
                >
                  ---
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Date de publication</div>
                <div class="text-gray-600">
                  {{
                    !jobofferDetails?.start_date
                      ? "---"
                      : jobofferDetails?.start_date
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                  }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Date de candidature</div>
                <div class="text-gray-600">
                  {{
                    !jobofferDetails?.date_postule
                      ? "---"
                      : jobofferDetails?.date_postule
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                  }}
                </div>
              </div>
              <!-- <div class="flex-space ">
                                <div class="contact-info-name ">Date</div>
                                <div class="text-gray-600">{{ (jobofferDetails?.start_date || '---').split(' ')[0] }}</div>
                            </div> -->
              <!--begin::Details item-->
              <!--begin::Details item-->

              <!--begin::Details item-->
              <!--begin::Details item-->

              <!--begin::Details item-->
              <!--begin::Details item-->

              <!--begin::Details item-->
            </div>
            <!--end::Details toggle-->

            <!--end::Details content-->
          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
      </div>
      <!--end::Sidebar-->
      <!--begin::Content-->
      <div class="flex-lg-row-fluid">
        <!--begin:::Tabs-->
        <div class="card card-right pt-4 mb-6 mb-xl-9">
          <!--begin::Card header-->
          <div class="card-header border-0">
            <!--begin::Card title-->
            <div class="card-title flex-column">
              <h2 class="mb-1">
                <svg
                  width="34"
                  height="40"
                  viewBox="0 0 34 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_126_200)">
                    <mask
                      id="mask0_126_200"
                      style="mask-type: luminance"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="34"
                      height="34"
                    >
                      <path d="M33.1272 0H0V33.2H33.1272V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_126_200)">
                      <path
                        d="M12.423 2.07499C11.131 2.07499 10.1477 2.07046 9.3194 2.16415C8.49111 2.25783 7.73291 2.46482 7.16602 3.03346C6.59921 3.60209 6.39364 4.36177 6.30064 5.19156C6.2078 6.01983 6.21166 7.00397 6.21167 8.29389C6.21167 8.29457 6.21167 8.29524 6.21167 8.29592V8.29997V20.7541C6.21148 23.1225 6.0608 24.5238 6.90722 25.7106C7.33069 26.3044 8.01481 26.6431 8.71679 26.7906C9.20428 26.893 9.76589 26.927 10.3808 26.9466C10.3936 27.3216 10.4054 27.6905 10.4415 28.0105C10.535 28.8407 10.7414 29.6025 11.3089 30.1706C11.8763 30.7386 12.6344 30.9427 13.4622 31.0358C14.2901 31.1289 15.2734 31.125 16.5639 31.125H22.7025C22.7267 31.1265 22.751 31.1272 22.7752 31.127C24.0658 31.127 25.049 31.1311 25.8769 31.0378C26.7047 30.9446 27.4628 30.7386 28.0303 30.1706C28.5976 29.6025 28.8042 28.8427 28.8977 28.0125C28.9911 27.1828 28.9866 26.1957 28.9866 24.902V12.45C28.9869 12.4046 28.9842 12.3592 28.9785 12.3142C28.9784 11.5259 28.9721 10.8971 28.653 10.2574C28.3144 9.57859 27.8098 9.11651 26.9546 8.25943C26.0993 7.40172 25.6447 6.89802 24.9671 6.55731C24.8557 6.50129 24.7446 6.46636 24.6335 6.42762C24.5207 6.11863 24.3632 5.81855 24.1603 5.55223C23.8329 5.12229 23.4209 4.71792 22.8137 4.10948C21.9584 3.25177 21.5038 2.74808 20.8262 2.40736C20.1696 2.07726 19.5284 2.0769 18.7032 2.07706C18.6789 2.07553 18.6546 2.07486 18.6304 2.07504L12.423 2.07499ZM12.423 4.14999H17.5991V6.22499H16.5639C15.2719 6.22499 14.2886 6.22046 13.4603 6.31415C12.632 6.40783 11.8738 6.61482 11.3069 7.18346C10.7401 7.75209 10.5345 8.51177 10.4415 9.34156C10.3487 10.1698 10.3526 11.154 10.3526 12.4439C10.3526 12.4446 10.3526 12.4452 10.3526 12.4459V12.45V24.8699C9.84479 24.8488 9.41116 24.8171 9.14146 24.7605C8.72636 24.6733 8.66662 24.6084 8.5915 24.5031C8.44136 24.2926 8.28235 23.1205 8.28214 20.7543V8.29601C8.28216 7.00577 8.28869 6.04972 8.35898 5.42265C8.42935 4.79485 8.54842 4.5824 8.62992 4.50066C8.7114 4.41891 8.92543 4.29795 9.55191 4.2271C10.1784 4.15624 11.1321 4.14999 12.423 4.14999ZM19.6696 4.20672C19.7466 4.22271 19.8398 4.23318 19.896 4.26144C20.0856 4.35673 20.4949 4.71725 21.3498 5.5745C21.3498 5.57517 21.3498 5.57585 21.3498 5.57652C21.6681 5.89554 21.7638 6.01705 21.9604 6.22496H19.6696L19.6696 4.20672ZM16.5639 8.29997H21.74V12.45C21.7401 13.0229 22.2035 13.4874 22.7752 13.4875H26.9161V24.902V24.9041C26.9161 26.1967 26.91 27.152 26.8393 27.7795C26.7686 28.4074 26.6479 28.6198 26.5664 28.7015C26.4848 28.7832 26.2728 28.9045 25.6464 28.9751C25.0327 29.0441 24.0941 29.0518 22.844 29.0521C22.8198 29.0505 22.7955 29.0499 22.7712 29.05H16.5639C15.2741 29.05 14.3193 29.0455 13.6928 28.9751C13.0664 28.9046 12.8544 28.7831 12.7729 28.7015C12.6914 28.6199 12.5706 28.4074 12.4999 27.7795C12.4293 27.1524 12.4231 26.1958 12.4231 24.9041V12.4499V12.4459C12.4231 11.1556 12.4296 10.1996 12.4999 9.57252C12.5703 8.94471 12.6894 8.73226 12.7708 8.65052C12.8523 8.56877 13.0664 8.44781 13.6928 8.37696C14.3193 8.30611 15.273 8.29997 16.5639 8.29997ZM23.8105 8.35671C23.8875 8.37269 23.9807 8.38317 24.0369 8.41142C24.2265 8.50672 24.6358 8.86724 25.4907 9.72448C25.4907 9.72516 25.4907 9.72583 25.4907 9.72651C26.3448 10.5824 26.7049 10.991 26.8009 11.1835C26.8294 11.2407 26.8395 11.3344 26.8555 11.4124H23.8105L23.8105 8.35671Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 20.7543C15.3894 20.7523 15.2532 20.7777 15.1259 20.829C14.9986 20.8802 14.8827 20.9564 14.785 21.0529C14.6873 21.1494 14.6097 21.2645 14.5568 21.3913C14.5038 21.5181 14.4766 21.6543 14.4766 21.7918C14.4766 21.9292 14.5038 22.0654 14.5568 22.1922C14.6097 22.3191 14.6873 22.4341 14.785 22.5306C14.8827 22.6272 14.9986 22.7033 15.1259 22.7545C15.2532 22.8058 15.3894 22.8312 15.5265 22.8293H23.8104C23.9476 22.8312 24.0838 22.8058 24.2111 22.7545C24.3384 22.7033 24.4542 22.6272 24.5519 22.5306C24.6496 22.4341 24.7272 22.3191 24.7802 22.1922C24.8331 22.0654 24.8604 21.9292 24.8604 21.7918C24.8604 21.6543 24.8331 21.5181 24.7802 21.3913C24.7272 21.2645 24.6496 21.1494 24.5519 21.0529C24.4542 20.9564 24.3384 20.8802 24.2111 20.829C24.0838 20.7777 23.9476 20.7523 23.8104 20.7543H15.5265Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 16.6041C15.3894 16.6022 15.2532 16.6276 15.1259 16.6788C14.9986 16.7301 14.8827 16.8062 14.785 16.9027C14.6873 16.9993 14.6097 17.1143 14.5568 17.2411C14.5038 17.368 14.4766 17.5041 14.4766 17.6416C14.4766 17.7791 14.5038 17.9152 14.5568 18.0421C14.6097 18.1689 14.6873 18.2839 14.785 18.3805C14.8827 18.477 14.9986 18.5531 15.1259 18.6044C15.2532 18.6557 15.3894 18.6811 15.5265 18.6791H23.8104C23.9476 18.6811 24.0838 18.6557 24.2111 18.6044C24.3384 18.5531 24.4542 18.477 24.5519 18.3805C24.6496 18.2839 24.7272 18.1689 24.7802 18.0421C24.8331 17.9152 24.8604 17.7791 24.8604 17.6416C24.8604 17.5041 24.8331 17.368 24.7802 17.2411C24.7272 17.1143 24.6496 16.9993 24.5519 16.9027C24.4542 16.8062 24.3384 16.7301 24.2111 16.6788C24.0838 16.6276 23.9476 16.6022 23.8104 16.6041H15.5265Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 24.9042C15.3894 24.9022 15.2532 24.9276 15.1259 24.9789C14.9986 25.0301 14.8827 25.1063 14.785 25.2028C14.6873 25.2993 14.6097 25.4144 14.5568 25.5412C14.5038 25.668 14.4766 25.8042 14.4766 25.9417C14.4766 26.0792 14.5038 26.2153 14.5568 26.3421C14.6097 26.469 14.6873 26.584 14.785 26.6805C14.8827 26.7771 14.9986 26.8532 15.1259 26.9044C15.2532 26.9557 15.3894 26.9811 15.5265 26.9792H23.8104C23.9476 26.9811 24.0838 26.9557 24.2111 26.9044C24.3384 26.8532 24.4542 26.7771 24.5519 26.6805C24.6496 26.584 24.7272 26.469 24.7802 26.3421C24.8331 26.2153 24.8604 26.0792 24.8604 25.9417C24.8604 25.8042 24.8331 25.668 24.7802 25.5412C24.7272 25.4144 24.6496 25.2993 24.5519 25.2028C24.4542 25.1063 24.3384 25.0301 24.2111 24.9789C24.0838 24.9276 23.9476 24.9022 23.8104 24.9042H15.5265Z"
                        fill="#265D91"
                      />
                    </g>
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_126_200"
                      x="2.20117"
                      y="2.07495"
                      width="30.7852"
                      height="37.052"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_126_200"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_126_200"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
                Description
              </h2>
            </div>
            <!--end::Card title-->
            <!--begin::Card toolbar-->

            <!--end::Card toolbar-->
          </div>
          <!--end::Card header-->
          <!--begin::Card body-->

          <!--end::Card body-->
        </div>
        <div class="content">
          <div class="row descri mb-4 p-5">
            <p [innerHTML]="safeDescription"></p>
          </div>
        </div>
        <div class="card card-right pt-4 mb-6 mb-xl-9">
          <!--begin::Card header-->
          <div class="card-header border-0">
            <!--begin::Card title-->
            <div class="card-title flex-column">
              <h2 class="mb-1 info-person">
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_126_343)">
                    <path
                      d="M11.101 0.00083786C10.2458 0.00083786 9.53345 0.714159 9.53345 1.57104V1.75817C9.355 1.82241 9.17684 1.89502 9.00313 1.97602L8.87209 1.84475C8.26677 1.23812 7.25968 1.23812 6.65436 1.84475L5.84076 2.65945C5.23545 3.26608 5.23545 4.2749 5.84076 4.88097L5.97181 5.01224C5.89095 5.1854 5.81846 5.36304 5.75433 5.54346H5.56752C4.7121 5.54346 4 6.25678 4 7.11366V8.26799C4 9.12515 4.7121 9.83847 5.56752 9.83847H5.75433C5.81846 10.02 5.89095 10.196 5.97181 10.3694L5.84076 10.5007C5.23545 11.1073 5.23545 12.1158 5.84076 12.7222L6.65436 13.5372C7.25968 14.1438 8.26677 14.1438 8.87209 13.5372L9.00313 13.4059C9.176 13.4869 9.35361 13.5595 9.53345 13.6238V13.8109C9.53345 14.6681 10.2458 15.3814 11.101 15.3814H12.2533C13.109 15.3814 13.8214 14.6681 13.8214 13.8109V13.6238C13.9999 13.5595 14.178 13.4869 14.3514 13.4059L14.4825 13.5372C15.0881 14.1438 16.0952 14.1438 16.7002 13.5372L17.5141 12.7222C18.1194 12.1158 18.1194 11.1073 17.5141 10.5007L17.383 10.3694C17.4639 10.1962 17.5364 10.0189 17.6005 9.83847H17.7873C18.643 9.83847 19.3551 9.12515 19.3551 8.26799V7.11366C19.3551 6.25678 18.643 5.54346 17.7873 5.54346H17.6033C17.5392 5.36192 17.4639 5.18541 17.383 5.0114L17.5141 4.88014C18.1194 4.27406 18.1194 3.26525 17.5141 2.65862L16.7002 1.84391C16.0952 1.23728 15.0881 1.23728 14.4825 1.84391L14.3514 1.97518C14.1786 1.89418 14.0007 1.81877 13.8206 1.75454V1.5702C13.8206 0.713321 13.1082 0 12.2525 0L11.101 0.00083786ZM11.101 1.46574H12.2533C12.3258 1.46574 12.3593 1.49926 12.3593 1.57188V2.29246C12.3592 2.45441 12.4128 2.61181 12.5115 2.74006C12.6102 2.8683 12.7486 2.96018 12.9049 3.00131C13.3321 3.11303 13.7419 3.2834 14.1228 3.50684C14.2624 3.58865 14.4252 3.62178 14.5856 3.60106C14.7461 3.58034 14.8951 3.50694 15.0095 3.39233L15.5175 2.88317C15.5677 2.8329 15.6151 2.8329 15.6652 2.88317L16.4788 3.69816C16.529 3.74843 16.529 3.79591 16.4788 3.84618L15.9708 4.35562C15.8564 4.47016 15.7831 4.61946 15.7624 4.78017C15.7418 4.94087 15.7748 5.10391 15.8565 5.24378C16.0796 5.6253 16.2491 6.03558 16.3612 6.46346C16.4022 6.6201 16.4938 6.75873 16.6218 6.85767C16.7498 6.95661 16.9069 7.01029 17.0685 7.01032H17.7879C17.8604 7.01032 17.8938 7.04384 17.8938 7.11646V8.27079C17.8938 8.3434 17.8604 8.37692 17.7879 8.37692H17.0652C16.9032 8.37685 16.7458 8.43065 16.6176 8.52987C16.4894 8.6291 16.3978 8.76814 16.357 8.92518C16.2455 9.35278 16.0773 9.76334 15.8557 10.1451C15.7744 10.2848 15.7416 10.4475 15.7622 10.6079C15.7829 10.7682 15.856 10.9172 15.97 11.0316L16.478 11.5408C16.5282 11.5911 16.5282 11.6385 16.478 11.6888L15.6644 12.5041C15.6142 12.5543 15.5668 12.5543 15.5166 12.5041L15.0086 11.9949C14.8944 11.8806 14.7456 11.8074 14.5855 11.7867C14.4253 11.766 14.2629 11.7989 14.1234 11.8804C13.7422 12.1038 13.3324 12.2717 12.9055 12.3829C12.7488 12.4237 12.61 12.5155 12.5109 12.6438C12.4119 12.7721 12.3582 12.9298 12.3582 13.092V13.8159C12.3582 13.8885 12.3247 13.9221 12.2522 13.9221H11.0999C11.0274 13.9221 10.9939 13.8885 10.9939 13.8159V13.092C10.9939 12.9298 10.9402 12.7722 10.8412 12.6439C10.7422 12.5155 10.6035 12.4237 10.4469 12.3829C10.0197 12.2711 9.61012 12.1027 9.22898 11.8804C9.08949 11.7989 8.92702 11.766 8.76689 11.7867C8.60676 11.8074 8.45797 11.8806 8.34372 11.9949L7.83544 12.5041C7.78525 12.5543 7.73785 12.5543 7.68766 12.5041L6.87435 11.6888C6.82416 11.6385 6.82416 11.5911 6.87435 11.5408L7.38236 11.0316C7.49638 10.9172 7.56942 10.7682 7.5901 10.6079C7.61077 10.4475 7.57793 10.2848 7.49667 10.1451C7.2764 9.76334 7.10605 9.35278 6.99508 8.92518C6.95431 8.76818 6.86269 8.62918 6.73457 8.52996C6.60646 8.43074 6.44909 8.37691 6.28715 8.37692H5.56418C5.49168 8.37692 5.45822 8.3434 5.45822 8.27079V7.11646C5.45822 7.04384 5.49168 7.01032 5.56418 7.01032H6.28715C6.44909 7.01033 6.60646 6.95651 6.73457 6.85729C6.86269 6.75806 6.95431 6.61906 6.99508 6.46207C7.1066 6.03419 7.27501 5.6239 7.49667 5.2421C7.57793 5.10241 7.61077 4.93972 7.5901 4.77938C7.56942 4.61903 7.49638 4.47004 7.38236 4.35562L6.87435 3.84646C6.82416 3.79619 6.82416 3.74871 6.87435 3.69843L7.68766 2.88373C7.73785 2.83346 7.78525 2.83346 7.83544 2.88373L8.34372 3.39261C8.45797 3.50689 8.60676 3.58009 8.76689 3.60081C8.92702 3.62152 9.08949 3.58858 9.22898 3.50712C9.61012 3.28368 10.0197 3.11582 10.4469 3.00466C10.6035 2.96378 10.7422 2.87198 10.8412 2.74365C10.9402 2.61532 10.9939 2.45771 10.9939 2.29553V1.57132C10.9939 1.4987 11.0285 1.46574 11.101 1.46574ZM21.4672 4.02968C21.4043 4.02144 21.3405 4.02144 21.2776 4.02968C21.1512 4.05243 21.0333 4.1081 20.9352 4.19111C20.8372 4.27411 20.7626 4.38152 20.7191 4.50253C20.6866 4.59307 20.6722 4.68913 20.6768 4.78523C20.6814 4.88134 20.7048 4.9756 20.7457 5.06264C20.7866 5.14968 20.8443 5.22779 20.9154 5.29251C20.9864 5.35723 21.0695 5.4073 21.1599 5.43984C24.0602 6.48469 26.1374 9.25698 26.1377 12.5264C26.1366 12.6074 26.1374 12.6018 26.1371 12.694C26.1369 12.789 26.1366 12.9146 26.1363 13.0398C26.1357 13.2883 26.1349 13.5361 26.1349 13.5361C26.1349 13.6299 26.1529 13.7228 26.1879 13.8098L27.6952 17.5912H26.3738C26.2778 17.5911 26.1827 17.6101 26.0939 17.6469C26.0051 17.6837 25.9245 17.7376 25.8566 17.8057C25.7886 17.8737 25.7347 17.9545 25.6979 18.0434C25.6612 18.1323 25.6422 18.2275 25.6422 18.3238V21.0497H22.0304C21.8644 21.0497 21.7034 21.1064 21.5738 21.2102C21.4442 21.314 21.3537 21.4589 21.3172 21.6211L20.6918 24.3982H14.2979L15.1221 19.7605C15.1483 19.6134 15.129 19.4619 15.0668 19.3262C15.0046 19.1905 14.9025 19.077 14.7741 19.001C14.0475 18.5712 13.4104 18.0299 12.879 17.4063C12.753 17.2586 12.5736 17.1671 12.3802 17.1519C12.1868 17.1367 11.9954 17.1991 11.8479 17.3253C11.7006 17.4515 11.6093 17.6312 11.5941 17.8248C11.579 18.0184 11.6412 18.2101 11.7671 18.3578C12.2935 18.9759 12.9083 19.5244 13.5967 19.9872L12.7056 25.0028C12.6868 25.1082 12.6914 25.2164 12.7189 25.3199C12.7464 25.4233 12.7963 25.5195 12.8648 25.6015C12.9334 25.6836 13.0192 25.7496 13.116 25.795C13.2128 25.8403 13.3183 25.8638 13.4252 25.8639H21.2773C21.4433 25.8639 21.6044 25.8073 21.7341 25.7035C21.8637 25.5996 21.9543 25.4547 21.9908 25.2925L22.6159 22.5154H26.3744C26.5684 22.5154 26.7544 22.4382 26.8915 22.3008C27.0287 22.1634 27.1057 21.9771 27.1057 21.7828V19.0569H28.7753C28.8948 19.0569 29.0125 19.0276 29.1181 18.9716C29.2237 18.9155 29.3139 18.8344 29.381 18.7353C29.448 18.6362 29.4898 18.5221 29.5027 18.4031C29.5155 18.2841 29.4991 18.1637 29.4548 18.0526L27.5993 13.3989C27.5995 13.3124 27.5998 13.223 27.6004 13.0445C27.6006 12.9188 27.6009 12.7959 27.6012 12.699C27.6015 12.6041 27.6034 12.4532 27.6018 12.5454C27.602 8.65286 25.1247 5.32729 21.6562 4.07772C21.5961 4.05561 21.5332 4.04153 21.4694 4.03582L21.4672 4.02968ZM11.6773 4.12185C9.71663 4.12185 8.11175 5.72947 8.11175 7.69348C8.11175 9.65749 9.71663 11.2654 11.6773 11.2654C13.6382 11.2654 15.2431 9.65749 15.2431 7.69348C15.2431 5.72947 13.6382 4.12185 11.6773 4.12185ZM11.6773 5.58675C12.8475 5.58675 13.7804 6.52128 13.7804 7.69348C13.7804 8.86569 12.8475 9.80021 11.6773 9.80021C10.5074 9.80021 9.57443 8.86569 9.57443 7.69348C9.57443 6.52128 10.5074 5.58675 11.6773 5.58675Z"
                      fill="#265D91"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_126_343"
                      x="0"
                      y="0"
                      width="33.5068"
                      height="33.8638"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_126_343"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_126_343"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
                Compétences maitrisées
              </h2>
            </div>
            <!--end::Card title-->
          </div>
          <!--end::Card header-->
        </div>
        <div class="container modules mb-10">
          <div class="table-responsive compt">
            <table class="table align-middle fs-6 gy-5 mb-0">
              <thead>
                <tr class="text-start fw-bold fs-7 text-uppercase gs-0">
                  <th>Catégorie</th>
                  <th>Compétences</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let categorie of skills; let i = index">
                  <td>
                    <div
                      class="bg1"
                      [style.background-color]="
                        colorsHeader[i % colorsHeader.length]
                      "
                    >
                      {{ categorie?.name_FR }}
                    </div>
                  </td>
                  <td class="brd-compt">
                    <ng-container *ngFor="let sub of categorie.subcategories">
                      <div class="badge badge-light-default">
                        {{ sub?.name_FR }}
                      </div>
                    </ng-container>
                  </td>
                </tr>
                <tr *ngIf="jobofferDetails?.otherSkills">
                  <td><div class="bg1">Autre compétence</div></td>
                  <td class="brd-compt">
                    <ng-container
                      *ngFor="let skills of jobofferDetails?.otherSkills"
                    >
                      <div class="badge badge-light-default">
                        {{ skills }}
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--end::Content-->
    </div>
  </div>
  <!--end::Content container-->
</div>
